import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import Address from "../Address";
import Alert from "../Alert";
import BaseCom from "../BaseCom";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class Checkout extends BaseCom {
    constructor(props) {
        super(props);
        const months = [];
        const years = [];
        for (let n = 1; n <= 12; n++)
            months.push({ id: n, name: n });

        var y = new Date().getFullYear();
        for (let n = y; n <= (y + 20); n++)
            years.push({ id: n, name: n });

        this.state = {
            info: {
                billingAddress: {}
            },
            months: months,
            years: years,
            paymentMethodList: []
        };
    }

    async componentDidMount() {
        await this.loadPO(this.props.currentItem);
    }

    async componentDidUpdate(prevProps) {
        if(this.props.currentItem !== prevProps.currentItem) {
            
            await this.loadPO(this.props.currentItem);
        }
    }

    loadPO = async (item) => {
        if(!this.props.currentItem) return;
        await this.fillItemAsync('/api/purchase-order/get/' + item.id, 'item');
    }

    success = () => {
        this.setState({ success: true });
        this.props.onSuccess?.();
    }

    error = (str) => {
        this.setState({ error: str });
    }

    change = () => {
        this.setState({ info: {...this.state.info}, error: null });
    }

    submit = async (e) => {
        e?.preventDefault();
        this.setState({ submitting: true });
        try {
            let data = {
                ...this.state.info,
                ...this.props.currentItem, paymentMethod: { ...this.state.info },
                purchaseOrderID: this.props.currentItem.id,
                name: this.state.info.name // always override card name
            };
            

            // override when use billing address
            if(this.state.info.useSubmitBillingAddress) {
                data.billingAddress = this.state.info.billingAddress;
            }

            let j = await qreq.postAsync('/api/payment/checkout2', data);

            if (j.errorCode === 0)
                this.success();
            else
                this.error(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    render() {
        return (<form onSubmit={this.submit}>
            <div className="bg-light rounded my-2 p-3">
                <FormInput
                    model={this.state.info}
                    name="name"
                    label="Name on card"
                    type="text"
                    placeholder=""
                    onChange={this.change}
                    required
                />
                <FormInput
                    model={this.state.info}
                    name="cardNumber"
                    label="Card Number"
                    type="text"
                    placeholder="0000 0000 0000 0000"
                    autoComplete="cc-number"
                    onChange={this.change}
                    />
                <div className="row">
                    <div className="col-md-6">
                        <label className="mb-2">Expires</label>
                        <div className="row">
                            <div className="col">
                                <FormInput
                                    model={this.state.info}
                                    name="expMonth"
                                    label="MM"
                                    type="select"
                                    options={this.state.months}
                                    labelAsPlaceholder
                                    selectDefault="MM"
                                    autoComplete="cc-exp-month"
                                    onChange={this.change}
                                />
                            </div>
                            <div className="col">
                                <FormInput
                                    model={this.state.info}
                                    name="expYear"
                                    label="YYYY"
                                    type="select"
                                    options={this.state.years}
                                    labelAsPlaceholder
                                    selectDefault="YYYY"
                                    autoComplete="cc-exp-year"
                                    onChange={this.change}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <FormInput
                            model={this.state.info}
                            name="cvc"
                            label="CVC"
                            type="text"
                            autoComplete="cc-csc"
                            onChange={this.change}
                        />
                    </div>
                </div>

                <div>
                    <div className="mb-3">
                        <FormInput
                            type="switch"
                            model={this.state.info}
                            name="useSubmitBillingAddress"
                            onChange={this.change}
                            label="Use a different billing address."
                        />
                    </div>

                    {this.state.info.useSubmitBillingAddress && <Address item={this.state.info.billingAddress} name="billingAddress" onChange={this.change} required />}
                </div>

                <div>
                    <p>Total Amount: <strong>{Globals.formatCurrency(this.state.item?.totalUpfrontFee)}</strong></p>
                </div>
            </div>
            <div className="text-end mb-1">
                <button type="submit" className="btn btn-success btn-lg" disabled={this.state.submitting}>
                    <Icon icon="faCreditCard" /> Pay Now
                </button>
            </div>
            {this.state.error && <Alert type="danger">{this.state.error}</Alert>}
        </form>);
    }
}

export default withParamsAndNavigate(Checkout);